import { Component, h, Host, Prop, State, Watch } from '@stencil/core';
import { store } from '../../redux/store';
import { ErrorLayout, RtrError, Translations } from '../../redux/types';
import { removeErrorKey } from '../../redux/actions';
import { trans } from '../../utils/trans';

const errorLifeTime = 10000;

@Component({
  tag: 'rtr-single-error',
  shadow: false,
  styleUrl: 'style.sass',
})
export class RtrSingleError {
  @Prop() error!: RtrError;
  @Prop() index!: number;
  @Prop() locale!: string;
  @Prop() translations!: Translations;

  @State() pauseable: boolean;
  @State() paused: boolean;

  startedAt: number = new Date().valueOf();
  timeLeft: number = errorLifeTime;
  errorTimer;
  errorContainerEl: HTMLDivElement;

  removeErrorKey!: typeof removeErrorKey;

  componentWillLoad() {
    store.mapDispatchToProps(this, {
      removeErrorKey,
    });
  }

  componentDidLoad() {
    this.runTimer();
    setTimeout(() => {
      if (this.errorContainerEl.parentNode.querySelector(':hover') == this.errorContainerEl) {
        this.handleStopTimer();
      }
      this.pauseable = true;
    }, 500);
  }

  @Watch('error')
  errorChanged(newError: RtrError, oldError: RtrError) {
    if (newError.errorKey !== oldError.errorKey) {
      clearTimeout(this.errorTimer);
      this.timeLeft = errorLifeTime;
      this.runTimer();
    }
  }

  runTimer = () => {
    this.startedAt = new Date().valueOf();
    this.errorTimer = setTimeout(() => {
      this.removeErrorKey(this.error.errorKey);
    }, this.timeLeft);
  };

  handleStopTimer = () => {
    this.paused = true;
    this.timeLeft = this.timeLeft - (new Date().valueOf() - this.startedAt);
    clearTimeout(this.errorTimer);
  };

  handleStartTimer = () => {
    this.paused = false;
    this.runTimer();
  };

  removeThisError = () => {
    this.removeErrorKey(this.error.errorKey);
  };

  render() {
    const title = this.error.layout === ErrorLayout.Success ? trans('error.success', this.locale, this.translations) : trans('error.error', this.locale, this.translations);
    return (
      <Host>
        <div
          key={this.error.errorKey}
          ref={el => (this.errorContainerEl = el)}
          class={{ RtrErrorContainerInner: true, RtrErrorPauseable: this.pauseable, RtRSuccess: this.error.layout === ErrorLayout.Success }}
          onMouseOver={this.pauseable && !this.paused && this.handleStopTimer}
          onMouseLeave={this.pauseable && this.paused && this.handleStartTimer}
        >
          <div class="RtrErrorContainerTimer" key={this.error.errorKey} />
          <div class="RtrErrorTitle">
            <span>{title}</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={this.removeThisError}>
              <path d="M6 6L11 1M6 6L11 11M6 6L1 1M6 6L1 11" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div class="RtrErrorBox">{this.error.message}</div>
        </div>
      </Host>
    );
  }
}
